import axios from 'axios';

/**
 * The state for fulfillment drawer.
 */
const state = () => ({
    // The state to check if drawer is open
    isDrawerOpen: false
});

// mutations
const mutations = {
    /**
     * Toggle the drawer state.
     * @param {*} state
     */
    toggleDrawer(state) {
        state.isDrawerOpen = !state.isDrawerOpen;
    }
};

// getters
const getters = {
    /**
     * Returns the drawer state.
     * @returns {Boolean}.
     */
    isDrawerOpen(state) {
        return state.isDrawerOpen;
    }
};

// actions
const actions = {
    /**
     * Toggle the Fulfillment Drawer state.
     * @param {Boolean} isOpen:
     */
    toggleDrawer({ commit, state }) {
        commit('toggleDrawer');
        return state.isDrawerOpen;
    },
    /**
     * Fetch the fulfillment draft order for a campaign from FF API
     * @param {Object} context
     * @param {Object} campaign
     */
    async getFulfillmentDraftOrder(unusedContext, campaign) {
        try {
            const { handle } = campaign;
            return axios.get(`/campaigns/${handle}/fulfillmentDraftOrder`).then((r) => r.data);
        } catch (unusedError) {
            throw new Error('Error loading the fulfillment draft order');
        }
    },
    /**
     * Fetch the fulfillment order for a campaign from FF API
     * @param {Object} context
     * @param {Object} campaign
     */
    async getFulfillmentOrder(unusedContext, campaign) {
        try {
            const { handle } = campaign;
            return axios.get(`/campaigns/${handle}/fulfillmentOrder`).then((r) => r.data);
        } catch (unusedError) {
            throw new Error('Error loading the fulfillment order');
        }
    },
    /**
     * Fetch the discount codes for a campaign from FF API
     */
    getInfluencerDiscountCodes(unusedContext, campaign) {
        try {
            const { handle } = campaign;
            return axios.get(`/campaigns/${handle}/getInfluencerDiscountCodes`).then((r) => r.data);
        } catch (unusedError) {
            throw new Error('Error loading the fulfillment draft order');
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
